<template>
    <div>
        <div v-if="!is_company_exist">
            <div class="error">
                התרחשה שגיאה, יש לחזור אחורה ולנסות שנית
            </div>
        </div>
        <div v-else>
            <form @submit.prevent="submitForm" class="form-container"> <label>{{ company.text1 }}</label>
                <input type="text" v-model="data1" required="" />
                <div class="buttons">
                    <button type="button" @click="goBack" :disabled="is_load">חזרה</button>
                    <button type="submit" :disabled="is_load && !store.is_debug">מימוש שובר מועדון</button>

                </div>


                <MiniLoader v-if="is_load" />
                <div class="error" v-if="error">{{ error }}</div>
            </form>
        </div>
    </div>
</template>
<style scoped></style>

<script>
import { store } from '@/store'
import axios from 'axios'
import { log } from '@/utils.js'
import MiniLoader from '@/components/loaders/MiniLoader.vue';


export default {
    components: {
        'MiniLoader': MiniLoader,
    },
    created() {
        if (!store.companies[store.company_key]) {
            this.is_company_exist = false;
        }

    },
    data() {
        return {
            store,
            is_company_exist: true,
            is_load: false,
            company: store.companies[store.company_key],
            data1: '',
            error: '',
        }
    },
    methods: {
        submitForm() {
            this.error = '';
            if (!this.data1) {
                this.error = "יש למלא את כל השדות בטופס";
                return false;
            }
            this.is_load = true;
            let formData = new FormData();
            formData.append('data1', this.data1);
            formData.append('company_key', this.company.key);
            formData.append('company_key2', this.company.key2);
            formData.append('id', store.id);
            formData.append('api_key', store.api_key);

            axios.post(store.api_url + '/gateway/check_data', formData).then(response => {
                if (response.data.error) {
                    this.error = response.data.message;
                } else {
                    let res = response.data.data;
                    if (store.is_debug) {
                        log(res);
                    }

                    if (res.success) {
                        window.location = res.success_url;
                    } else {
                        this.error = "התרחשה שגיאה לא ידועה, אמנם נראה שהקופון הופעל בהצלחה. יש לפנות למפעיל לבירור";
                    }
                }
                this.is_load = false;

            }).catch(error => {
                console.log(error);
            });

        },
        goBack() {
            store.company_key = '';
            this.$router.push({ name: 'home', params: {} });
        }

    }
}
</script>


<style scoped>
.form-container {
    background: white;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 0 auto;
}

input[type="text"] {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 8px;
}

input[type="submit"] {
    background-color: #1976d2;
    color: white;
    padding: 12px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
}

.buttons {
    display: flex;
    gap: 10px;
    justify-content: space-between;
}

button {
    flex: 1;
    padding: 12px;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
}

button[type="submit"] {
    background-color: #1976d2;
    color: white;
}

button[type="submit"]:hover {
    background-color: #1565c0;
}

button[type="button"] {
    background-color: #9e9e9e;
    color: white;
}

button[type="button"]:hover {
    background-color: #757575;
}
</style>